<script lang="ts">
    import {
        ChainedProvider,
        IForwardResult,
        OpenCageDataProvider,
        PreprocessingGeocodingProvider
    } from "@anyways-open/geocoding-common";
	import { _ } from "svelte-i18n";
    import type { SearchControlManager } from "./SearchControlManager";
    import Control from "../map/controls/Control.svelte";
    import CollapsibleControl from "../map/controls/CollapsibleControl.svelte";

    export let manager: SearchControlManager;
    const collapsedStore = manager.getCollapsedStore();
    const selectedResultStore = manager.getSelectedResultStore();

    let searchString: string = "";
    let searchResults: IForwardResult[] = [];

    const maxReverseDistance = 100;
    const openCageSettings = {
        language: "en",
        locale: "en"
    }
    const openCageProvider = new OpenCageDataProvider("dcec93be31054bc5a260386c0d84be98", openCageSettings);
    $: openCageSettings.locale = "en";

    const geocoderProvider = new ChainedProvider(
        [
            {
                provider: openCageProvider,
            },
        ],
        {
            maxResults: 5,
            maxReverseDistance: maxReverseDistance,
        }
    );
    const geocoder = new PreprocessingGeocodingProvider(geocoderProvider, (q) => {
        if (
            q &&
            q.string &&
            q.string.toLowerCase().startsWith("station ")
        ) {
            q = {
                string: q.string.substring(7),
                location: q.location,
            };
        }
        return q;
    });

    $: {
        if (searchString.length <= 0) {
            searchResults = [];
        } else {
            geocoder.forwardAsync({
                string: searchString
            }).then(result => {
                searchResults = result;
            });
        }
    }

    const onSelect = (result: IForwardResult) => {
        searchResults = []
        searchString = "";
        $selectedResultStore = result;
        //tripsManager.onZoomTo({ center: result.location, zoom: 14 });
        $collapsedStore = true;
    }
</script>

<CollapsibleControl class="search-control bg-white" {manager}>
    <div slot="content">
        <div class="input-group input-group-lg">
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <button class="input-group-text border-0 {$collapsedStore ? 'collapsed' : ''}" on:click={() => manager.onToggleCollapsed()}>
                <i class="fe fe-search" />
            </button>
    
            <input
                type="text"
                class="form-control border-0 px-1"
                bind:value={searchString}
                aria-label="{$_("search.placeholder")}"
                placeholder="{$_("search.placeholder")}" />
    
            <span class="input-group-text border-0 py-0 ps-1 pe-3">
                <span
                    class="h6 text-uppercase text-muted d-none d-md-block mb-0 me-5">
                </span>
            </span>
        </div>
        <div class="search-results rounded">
            <ul class="list-group px-0">
                {#each searchResults as result}
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <li class="list-group-item list-group-item-action" on:click={() => onSelect(result)}>{result.description}</li>
                {/each}
            </ul>
            
        </div>
    </div>
    <div slot="content-collapsed" class="d-flex flex-column justify-content-center align-items-center">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <button on:click={() => manager.onToggleCollapsed()} class="border-0 bg-transparent icon-collapsed">
            <i class="fe fe-search"></i>
        </button>
    </div>
</CollapsibleControl>

<style>
    .search-results {
        max-height: calc(100vh - 163px);
        overflow-y: scroll;
    }

    .list-group {
        font-size: 1.0625rem;
        padding-right: 1.5rem;
        padding-left: 1.5rem;
    }
</style>